import React, { useEffect, useState } from "react"
import { InputAdornment} from "@mui/material"
import AppDialog from "../../../components/Common/AppDialog"

import '../order.css';
import CustomSelect from "../../../components/Form/CustomSelect";
import CustomTextField from "../../../components/Form/CustomTextField";

const CollectPayment = (props) => {
    const [paymentType, setPaymentType] = useState();
    const [amount, setAmount] = useState();

    const handleSubmit = () => {
        let payload = {
            payment_type: paymentType,
            amount: amount
        }
        props.submit(payload);
    }

    return (
        <AppDialog
            open={props.open}
            close={() => props.close()}
            title={'Collect Payments'}
            titleIcon={'complete'}
            positiveTitle={'Mark as paid'}
            positivePress={() => handleSubmit()}
            negativePress={() => props.close()}
            negativeTitle={'Cancel'}
            width={'40%'}
        >
            <div className="">
                <CustomSelect
                    title={'Payment method'}
                    values={paymentType || '-1'}
                    labelName={'name'}
                    data={props?.paymentList || []}
                    placeholder={'Please select'}
                    onChange={setPaymentType}
                />
                <CustomTextField
                    title={'Amount'}
                    values={amount}
                    onChange={setAmount}
                    type={'number'}
                    placeholder={'0.00'}
                    InputProps={{
                        startAdornment: <InputAdornment position="start" className='auth-icon'>S$</InputAdornment>,
                    }}
                />
            </div>
        </AppDialog>
    )
}

export default CollectPayment;